module.exports = __webpack_public_path__ + "/bundle/asset/admission1-3-ed691145b25d204eca8dc4b7cce5a857.png";